if (!customElements.get("sub-widget")) {
  customElements.define(
    "sub-widget",
    class SubWidget extends HTMLElement {
      constructor() {
        super();
      }

      connectedCallback() {
        this.init();
      }

      init() {
        this.handlePlanClick = this.handlePlanClick.bind(this);

        this.sellingPlanInput = this.querySelector("input[type='hidden']");
        this.allPlans = this.querySelectorAll(".wt-subscription-widget__plans");

        this.addEventListeners();
        this.initHorizontalToggle();
        this.setInitialPlan();
      }

      setInitialPlan() {
        const initialPlanSelected = this.querySelector('.wt-subscription-widget__plans--selected');
        if (initialPlanSelected) {
          this.handlePlanClick(initialPlanSelected);
        }
      }

      reinit() {
        this.sellingPlanInput = this.querySelector("input[type='hidden']");
        this.allPlans = this.querySelectorAll(".wt-subscription-widget__plans");
        this.allPlans.forEach((plan) => {
          plan.addEventListener("click", () => this.handlePlanClick(plan));
        });

        this.addSelectListeners();
        this.initHorizontalToggle();
        this.setInitialPlan();
      }

      addEventListeners() {
        this.allPlans.forEach((plan) => {
          plan.addEventListener("click", () => this.handlePlanClick(plan));
        });

        this.addSelectListeners();

        this.unsubscribeVariantChange = subscribe(PUB_SUB_EVENTS.variantChange, (e) => {
          const wrapper = this.closest('[data-section-id]');
          const sectionId = wrapper?.dataset?.sectionId;
          const originalSectionId = wrapper?.dataset?.originalSectionId;
          if (sectionId && e.data.sectionId !== sectionId && e.data.sectionId !== originalSectionId) return;
          const previousSelectedPlanId = this.sellingPlanInput?.value || "";
          const wasSubscriptionSelected = this.querySelector('[data-plan-type="subscription"]')?.classList.contains(
            "wt-subscription-widget__plans--selected",
          );

          const parsedHTML = e.data.html.querySelector(".wt-subscription-widget__container");
          if (!parsedHTML) return;

          const currentContainer = this.querySelector('.wt-subscription-widget__container');
          if (!currentContainer) return;

          currentContainer.innerHTML = parsedHTML.innerHTML;
          this.reinit();

          if (wasSubscriptionSelected) {
            const subscriptionPlan = this.querySelector('[data-plan-type="subscription"]');
            const subscriptionSelect = subscriptionPlan?.querySelector("select");
            if (subscriptionSelect && subscriptionSelect.options.length > 0) {
              const matchingOption = [...subscriptionSelect.options].find(
                (option) => option.value === previousSelectedPlanId,
              );
              subscriptionSelect.value = matchingOption
                ? matchingOption.value
                : subscriptionSelect.options[0].value;
            }
            if (subscriptionPlan) this.handlePlanClick(subscriptionPlan);
          }

          if (originalSectionId) {
            const hiddenInput = this.querySelector('input[name="selling_plan"]');
            if (hiddenInput) hiddenInput.setAttribute('form', `product-form-${sectionId}`);
          }
        });
      }

      addSelectListeners() {
        this.querySelectorAll(".wt-subscription-widget__plan-content__select").forEach((select) => {
          select.addEventListener("change", (e) => {
            e.stopPropagation();
            this.handleSelectChange(select);
          });
        });
      }

      initHorizontalToggle() {
        if (this._horizontalClickHandler && this.horizontalRoot) {
          this.horizontalRoot.removeEventListener("click", this._horizontalClickHandler);
        }
        this.horizontalRoot = this.querySelector("[data-horizontal-toggle]");
        if (!this.horizontalRoot) {
          this._horizontalClickHandler = null;
          return;
        }
        this._horizontalClickHandler = (e) => {
          const btn = e.target.closest(
            ".wt-subscription-widget__horizontal-toggle__segment",
          );
          if (!btn || !this.horizontalRoot.contains(btn) || btn.disabled) return;
          e.preventDefault();
          const seg = btn.getAttribute("data-segment");
          const sub = this.querySelector('[data-plan-type="subscription"]');
          const ot = this.querySelector('[data-plan-type="one-time"]');
          if (seg === "subscription" && sub) sub.click();
          if (seg === "one_time" && ot) ot.click();
        };
        this.horizontalRoot.addEventListener("click", this._horizontalClickHandler);
        this.syncHorizontalSegments();
      }

      syncHorizontalSegments() {
        this.horizontalRoot = this.horizontalRoot || this.querySelector("[data-horizontal-toggle]");
        if (!this.horizontalRoot) return;
        const sub = this.querySelector('[data-plan-type="subscription"]');
        const ot = this.querySelector('[data-plan-type="one-time"]');
        const subBtn = this.horizontalRoot.querySelector('[data-segment="subscription"]');
        const otBtn = this.horizontalRoot.querySelector('[data-segment="one_time"]');
        const subOn = sub?.classList.contains("wt-subscription-widget__plans--selected");
        const otOn = ot?.classList.contains("wt-subscription-widget__plans--selected");
        subBtn?.classList.toggle("is-selected", !!subOn);
        otBtn?.classList.toggle("is-selected", !!otOn);
        subBtn?.setAttribute("aria-selected", subOn ? "true" : "false");
        otBtn?.setAttribute("aria-selected", otOn ? "true" : "false");
      }

      handleSelectChange(select) {
        const plan = select.closest(".wt-subscription-widget__plans");
        if (!plan || !plan.classList.contains("wt-subscription-widget__plans--selected")) return;

        const selectedOption = select.options[select.selectedIndex];
        if (!selectedOption) return;

        this.sellingPlanInput.value = selectedOption.value;

        const compareAtPrice = selectedOption.dataset.compareAtPrice;
        const price = selectedOption.dataset.price;
        this.updatePrice(plan, compareAtPrice, price);
        const titleEl = plan.querySelector(
          ".wt-subscription-widget__plan-header__title-text",
        );
        if (titleEl && selectedOption.textContent) {
          titleEl.textContent = selectedOption.textContent.trim();
        }
        this.updateURLParamsIfEnabled(selectedOption.value);
        const priceData = {
          price: selectedOption.dataset.priceFormatted,
          compareAtPrice: selectedOption.dataset.compareAtPriceFormatted,
          priceRaw: Number(selectedOption.dataset.priceRaw),
          compareAtPriceRaw: Number(selectedOption.dataset.compareAtPriceRaw),
        };
        this.updateProductPrices(priceData);
      }

      handlePlanClick(plan) {
        this.allPlans.forEach((item) => {
          item.classList.remove("wt-subscription-widget__plans--selected");
        });
        plan.classList.add("wt-subscription-widget__plans--selected");

        const selectedPlanValue = plan.querySelector("select")?.value;
        if (selectedPlanValue) {
          this.sellingPlanInput.value = selectedPlanValue;
          const selectedOption = [...plan.querySelector("select").options].find(
            (option) => option.value === selectedPlanValue
          );
          if (selectedOption) {
            const compareAtPrice = selectedOption.dataset.compareAtPrice;
            const price = selectedOption.dataset.price;
            this.updatePrice(plan, compareAtPrice, price);
            const titleEl = plan.querySelector(
              ".wt-subscription-widget__plan-header__title-text",
            );
            if (titleEl && selectedOption.textContent) {
              titleEl.textContent = selectedOption.textContent.trim();
            }
            const priceData = {
              price: selectedOption.dataset.priceFormatted,
              compareAtPrice: selectedOption.dataset.compareAtPriceFormatted,
              priceRaw: Number(selectedOption.dataset.priceRaw),
              compareAtPriceRaw: Number(selectedOption.dataset.compareAtPriceRaw),
            };
            this.updateProductPrices(priceData);
          }
        } else {
          this.sellingPlanInput.value = "";
          const priceData = {
            price: plan.dataset.priceFormatted,
            compareAtPrice: plan.dataset.compareAtPriceFormatted,
            priceRaw: Number(plan.dataset.priceRaw),
            compareAtPriceRaw: Number(plan.dataset.compareAtPriceRaw),
          };
          this.updateProductPrices(priceData);
        }

        this.updateURLParamsIfEnabled(selectedPlanValue);
        this.syncHorizontalSegments();
      }

      updatePrice(plan, compareAtPrice, price) {
        const priceElement = plan.querySelector('.wt-subscription-widget__plan-header__price-regular');
        const compareAtPriceElement = plan.querySelector('.wt-subscription-widget__plan-header__price-sale');

        if (compareAtPrice && compareAtPriceElement) {
          compareAtPriceElement.innerHTML = compareAtPrice;
        }
        if (priceElement) {
          if (compareAtPrice) {
            priceElement.classList.add('wt-subscription-widget__plan-header__price-regular--sale');
          } else {
            priceElement.classList.remove('wt-subscription-widget__plan-header__price-regular--sale');
          }
          if (price) {
            priceElement.innerHTML = price;
          }
        }
      }

      getSectionId() {
        return (
          this.closest('section[data-section-id]')?.dataset?.sectionId ||
          this.closest('[data-section-id]')?.dataset?.sectionId
        );
      }

      getMainPriceRoot(sectionId) {
        if (!sectionId) return null;
        return (
          document.getElementById(`price-${sectionId}`) ||
          this.closest('section[data-section-id]')?.querySelector(`#price-${sectionId}`) ||
          document.querySelector(`#shopify-section-${sectionId} #price-${sectionId}`)
        );
      }

      applyPriceToRoot(priceRoot, { price, compareAtPrice, priceRaw, compareAtPriceRaw }) {
        if (!priceRoot) return;

        const priceContainer = priceRoot.classList?.contains('price')
          ? priceRoot
          : priceRoot.querySelector('.price');
        if (!priceContainer) return;

        const priceRawNum = Number(priceRaw);
        const compareRawNum = Number(compareAtPriceRaw);
        const isOnSale =
          Number.isFinite(compareRawNum) &&
          Number.isFinite(priceRawNum) &&
          compareRawNum > priceRawNum;
        const isMainPdp = priceRoot.id?.startsWith('price-');

        priceContainer.classList.toggle('price--on-sale', isOnSale);

        priceContainer.querySelectorAll('.price__regular .wt-product__price__final').forEach((el) => {
          el.innerHTML = price;
        });

        priceContainer.querySelectorAll('.price__sale .wt-product__price__final, .price-item--sale.wt-product__price__final').forEach((el) => {
          el.innerHTML = price;
        });

        const saleDiv = priceContainer.querySelector('.price__sale');
        if (saleDiv) {
          if (isMainPdp) {
            saleDiv.classList.toggle('visible-main-product', isOnSale);
            saleDiv.classList.remove('visible');
          } else {
            saleDiv.classList.toggle('visible', isOnSale);
            saleDiv.classList.remove('visible-main-product');
          }
        }

        priceContainer.querySelectorAll('.wt-product__price__compare').forEach((compareEl) => {
          compareEl.innerHTML = isOnSale ? compareAtPrice : '';
          compareEl.classList.toggle('hidden', !isOnSale);
        });

        let percentEl = priceContainer.querySelector('.price-item--percent');
        if (isOnSale && compareRawNum > 0) {
          const percent = Math.round(((compareRawNum - priceRawNum) / compareRawNum) * 100);
          if (percentEl) {
            percentEl.textContent = `-${percent}%`;
          } else {
            const wrapper = priceContainer.querySelector('.price__sale__details-wrapper');
            if (wrapper) {
              percentEl = document.createElement('span');
              percentEl.className = 'price-item--percent';
              percentEl.textContent = `-${percent}%`;
              wrapper.appendChild(percentEl);
            }
          }
        } else if (percentEl) {
          percentEl.remove();
        }
      }

      mirrorPriceFromStickyToMain(stickyRoot, mainRoot) {
        const stickyPrice = stickyRoot.querySelector('.price');
        const mainPrice = mainRoot.querySelector('.price');
        if (!stickyPrice || !mainPrice) return;

        const preserveClasses = ['price--large', 'price--show-badge'];
        const preserved = preserveClasses.filter((className) => mainPrice.classList.contains(className));

        mainPrice.innerHTML = stickyPrice.innerHTML;
        mainPrice.className = stickyPrice.className;
        preserved.forEach((className) => mainPrice.classList.add(className));

        const mainSale = mainPrice.querySelector('.price__sale');
        if (mainSale?.classList.contains('visible')) {
          mainSale.classList.add('visible-main-product');
          mainSale.classList.remove('visible');
        }
      }

      updateProductPrices(priceData) {
        const sectionId = this.getSectionId();
        if (!sectionId) return;

        const stickyRoot = document.getElementById(`sticky-price-${sectionId}`);
        const mainRoot = this.getMainPriceRoot(sectionId);

        if (stickyRoot) this.applyPriceToRoot(stickyRoot, priceData);
        if (mainRoot) {
          if (stickyRoot) {
            this.mirrorPriceFromStickyToMain(stickyRoot, mainRoot);
          } else {
            this.applyPriceToRoot(mainRoot, priceData);
          }
        }

        if (typeof window.syncAddToCartPriceFromProductPrice === 'function') {
          window.syncAddToCartPriceFromProductPrice(sectionId);
        }
      }

      updateURLParamsIfEnabled(planId) {
        const wrapper = this.closest('[data-update-url-on-plan-change]');
        if (wrapper?.dataset.updateUrlOnPlanChange === 'false') return;

        const urlParams = new URLSearchParams(window.location.search);
        if (planId) {
          urlParams.set("selling_plan", planId);
        } else {
          urlParams.delete("selling_plan");
        }
        const query = urlParams.toString();
        const newUrl = query
          ? `${window.location.pathname}?${query}`
          : window.location.pathname;
        window.history.replaceState({}, "", newUrl);
      }

      disconnectedCallback() {
        if (this._horizontalClickHandler && this.horizontalRoot) {
          this.horizontalRoot.removeEventListener("click", this._horizontalClickHandler);
        }
        if (typeof this.unsubscribeVariantChange === 'function') {
          this.unsubscribeVariantChange();
        }
      }
    }
  );
}
